import React from 'react';
import { useAdminContext } from './adminContext';
import { AdminSocialModule } from '../../components/admin/AdminSocialModule';

export function AdminSocialPage() {
  const { adminKey } = useAdminContext();

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <AdminSocialModule adminKey={adminKey} />
    </div>
  );
}

export default AdminSocialPage;
